export default __webpack_public_path__ + "static/course-photo-2-3cbd96aa4f00c547ca022427e0455451.jpg";